import React from "react";
import { CustomMenuItems } from "./CustomMenuItems";
import { MenuItem } from "./MenuItem";
import { canViewWaivers, getPermissions } from "@/stores/globalStore";

export const CustomersMenuItems = () => {
    const permissions = getPermissions(); // Fetch permissions using getPermissions

    return (
        <>
            {permissions.canViewCustomers && <MenuItem isSubMenuItem route="customers/contacts" label="Contacts" />}
            {permissions.canViewMessageTemplates && (
                <MenuItem isSubMenuItem route="customers/messageTemplates" label="Message Templates" />
            )}
            {canViewWaivers() && <MenuItem isSubMenuItem route="customers/digitalWaivers" label="Digital Waivers" />}
            <CustomMenuItems route="customers" />
        </>
    );
};
